/**
 * @author: shangwei
 * @description: suggestion service
 * @Date: 2020-07-10
 */

import * as types from '@types';
import axios from 'axios';

export default {
  namespaced: true,
  state: () => ({
    head: '',
    itemData: [],
  }),
  mutations: {
    [types.UPDATE_HEAD](state, head) {
      state.head = head;
    },
    [types.UPDATE_HOTSUGG_DATA](state, itemData) {
      state.itemData = itemData;
    },
  },
  actions: {
    async prefetchData({ commit }, { context, route }) {
      const $params = context ? context.$params : {};
      const params = Object.assign({}, route.query, { routeName: route.name }, $params);
      let result = await axios({
        url: `${types.ORIGIN_CLIENT}/napi/video/hotsugg`,
        params,
        timeout: 4500,
      }).catch(err => console.log(err));

      result = result && result.data;
      const { status, head = '', itemData } = result || {};
      if (status === 0 && itemData) {
        commit(types.UPDATE_HEAD, head);
        commit(types.UPDATE_HOTSUGG_DATA, itemData);
        return result;
      }
      commit(types.UPDATE_HEAD, '');
      commit(types.UPDATE_HOTSUGG_DATA, {});

      return {
        status: 302,
        redirectUrl: '/?prefetch_redirect=1',
      };
    },
  },
};
